import React, {forwardRef, useCallback, useEffect, useImperativeHandle, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import PropTypes from "prop-types";
import classnames from "classnames";

import {substituteFromReact} from "@awe-web/shared/lib";
import {Translation as T} from "@awe-web/shared/lib";
import {getCmsPageContent, getCmsPageTitle} from "@awe-web/shared/lib";

import {Overlay, OverlayHeading, OverlaySection} from "./overlay.js";
import {Button} from "./form.js";
import {loadCmsPage} from "../cms/actions.js";

import "./cms_overlay.scss";

const BACK = "FSD0000105";

export const CmsOverlay = forwardRef(({pageName}, ref) => {

  const overlayRef = useRef();
  const dispatch = useDispatch();

  const pageTitle = useSelector(state => getCmsPageTitle(state, {pageName}));
  const pageContent = useSelector(state => getCmsPageContent(state, {pageName}));

  const loadedCmsPage = useRef();

  useImperativeHandle(ref, () => ({
    open: () => {
      if (overlayRef.current) {
        overlayRef.current.openOverlay();
      }
    }
  }));

  useEffect(() => {
    if (!pageName || pageName.length === 0) {
      return;
    }
    if (loadedCmsPage.current === pageName) {
      return;
    }

    dispatch(loadCmsPage(pageName));
    loadedCmsPage.current = pageName;
  }, [dispatch, pageName]);

  return (
    <Overlay ref={overlayRef} className="cms-overlay">
      {({closeOverlay}) => (
        <>
          <OverlayHeading>{pageTitle}</OverlayHeading>
          <OverlaySection>
            <div className="cms-overlay__content" dangerouslySetInnerHTML={{__html: pageContent}} />
          </OverlaySection>
          <OverlaySection>
            <Button secondary back className="cms-overlay__close-button" onClick={closeOverlay}>
              <T code={BACK} />
            </Button>
          </OverlaySection>
        </>
      )}
    </Overlay>
  );
});

export default function TextWithCmsLink({className, children, pageName, data}) {
  const overlayRef = useRef();
  const combinedClassName = classnames("text-with-cms-link", className);

  const openOverlay = useCallback((event) => {
    event.preventDefault();
    if (overlayRef.current) {
      overlayRef.current.open();
    }
  }, []);

  if (!pageName || pageName.length === 0) {
    return;
  }

  return (
    <>
      <span className={combinedClassName}>
        {substituteFromReact(children, data, {onLinkedTextClick: openOverlay})}
      </span>
      <CmsOverlay ref={overlayRef} pageName={pageName} />
    </>
  );
}

TextWithCmsLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.string,
  pageName: PropTypes.string,
  data: PropTypes.object
};